import React, { StatelessComponent } from 'react';
import b from 'b_';

import './publication.stub.css';

import Rect from '@components/rect';

const class_ = b.with('publication-page-stub');

const PublicationPageStub: StatelessComponent = () => {
    return (
        <div className={class_()}>
            <Rect className={class_('image')} />
            <Rect
                type="black"
                className={class_('title')}
                height={48}
            />

            <div className={class_('container')}>
                <div className={class_('main-info')}>
                    <Rect className={class_('content')} height={300} />

                    <div className={class_('buttons')}>
                        <Rect width={200} height={48} />
                        <Rect width={200} height={48} />
                    </div>
                </div>
                <div className={class_('dependencies-info')}>
                    <Rect className={class_('params')} height={300} />
                </div>
            </div>
        </div>
    );
};

export default PublicationPageStub;
